import type { Theme } from '@emotion/react';
import { css } from '@emotion/react';

import { animations, duration, easing } from '@twistopayments/design-system/styles';
import { defaultHtmlFontSizeMap } from '@twistopayments/design-system/theme';

export const heading = (theme: Theme) => css`
  font-size: ${defaultHtmlFontSizeMap.lg}px;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  padding: ${theme.spacing[4]} 0;
  cursor: pointer;
  border-radius: ${theme.borderRadius.sm};
`;

export const label = (theme: Theme) => css`
  display: flex;
  align-items: center;
  flex-grow: 1;

  svg {
    flex-shrink: 0;
    margin-right: ${theme.spacing[8]};
  }
`;

export const icon = css`
  flex-shrink: 0;
`;

export const startAdornment = (theme: Theme) => css`
  margin-right: ${theme.spacing[8]};
`;

export const chevron = (theme: Theme) => css`
  color: ${theme.palette.icons.main};
  margin-left: ${theme.spacing[8]};
  transition: ${duration.shortest}ms ${easing.easeIn};

  &.isExpanded {
    transform: rotate(180deg);
  }
`;

export const panel = (theme: Theme) => css`
  color: ${theme.palette.text.description};
  padding-top: ${theme.spacing[8]};
  animation: ${animations.fadeIn.name} ${duration.shortest}ms ${easing.easeIn};

  ${animations.fadeIn.definition}
`;

export const horizontalLine = (theme: Theme) => css`
  margin: ${theme.spacing[16]} 0;
`;
